export enum PanelStyle {
  PBasketBoughtThisSeasonVertical = 'PBVPAGT', // (p basket vertical panel automatic go to)
  ExtendedSimilarProducts = 'EXSP',
}
